var React = require('react');
var tsRest = require('ts-rest-client');
import createClass from 'create-react-class';

export const SessionSystemTest = createClass({
    displayName: "SessionSystemTest",

    propTypes: {
    },

    getDefaultProps: function () {
        return {  };
    },

    getInitialState: function () {
        return { sessionVal: "LOADING..."  };
    },
    
    componentDidMount: function(){
        this.refreshSessionValue();
    },

    refreshSessionValue: function(){
        console.log("Calling node");
        tsRest.get("test/session/testval").then((val) => {
            console.log("Node called");
            this.setState({ sessionVal: val });
        });

        tsapp.mvcapi.postCtl("test/test", {  })
             .success(function(data) {
                 this.setState({ mvcapiTest: data });
             }.bind(this));
        
    },
    
    handleSetValClick: function(){
        tsRest.put("test/session/testval/testouillette").then(this.refreshSessionValue);
    },
    
    render() {
        return (
            <div>
                <button onClick={this.handleSetValClick}>Set session val</button>

                <div><span>The val is: </span><span>{this.state.sessionVal}</span></div>
            </div>
        ); 
    }
});
